import React, { useEffect, useState } from "react";
import ReusableTable from "../../../../components/common/table";
import { Button, Popconfirm, Space } from "antd";
import { ReactComponent as AddSvg } from "../../../../assets/images/add.svg";
import FilterComponent from "../../../../components/common/filter";
import { useNavigate } from "react-router";
import ConfirmModal from "../../../../components/common/alert-popup";
import { ReactComponent as ViewSvg } from "../../../../assets/images/action/view.svg";
import { ReactComponent as DeleteSvg } from "../../../../assets/images/action/delete.svg";
import { ReactComponent as EditSvg } from "../../../../assets/images/action/edit.svg";
import { ReactComponent as DisableSvg } from "../../../../assets/images/action/Shield Cross.svg";
import CommonFilter from "../../../../components/common/filter";
import { Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserLogs } from "../../../../redux/reducer/LogsSlice";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import trimSearchValue, { useDebounce } from "../../../../customHooks";


const UserActivityList = () => {
  const [filteredData, setFilteredData] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [modalConfig, setModalConfig] = useState({
    open: false,
    actionType: "",
  });
  const [currentPage, setCurrentPage] = useState(1);

  const [searchParams, setSearchParams] = useSearchParams();
  // Convert URLSearchParams to usable object
const getInitialParams = () => {
  const page = parseInt(searchParams.get("page")) || 1;
  const size = parseInt(searchParams.get("size")) || 10;
  const search_key = searchParams.get("search_key") || "all";
  const search_value = searchParams.get("search_value") || "";
  const status = searchParams.get("status");
  const type = searchParams.get("type");
  const position = searchParams.get("position");
  const from_date = searchParams.get("from_date");
  const to_date = searchParams.get("to_date");


  return {
    page,
    size,
    search_key,
    search_value,
    from_date,
    to_date,
    status: status !== null ? Number(status) : undefined,
    type: type !== null ? Number(type) : undefined,
    position: position !== null ? Number(position) : undefined,
  };
};

const [tableParams, setTableParams] = useState(getInitialParams());

useEffect(() => {
  const params = {
    page: tableParams.page,
    size: tableParams.size,
    search_key: tableParams.search_key,
    search_value: tableParams.search_value,
    // from_date: undefined,
    // to_date: undefined,

  };

  if (tableParams.status !== undefined) params.status = tableParams.status;
  if (tableParams.type !== undefined) params.type = tableParams.type;
  if (tableParams.from_date !== undefined) params.from_date = tableParams.from_date;
  if (tableParams.to_date !== undefined) params.to_date = tableParams.to_date;
  if (tableParams.position !== undefined) params.position = tableParams.position;

  setSearchParams(params);
}, [tableParams, setSearchParams]);

  const {userLogs, userCount} = useSelector((prev) => prev?.userLogs)




  const debouncedSearchValue = useDebounce(tableParams.search_value, 500);

  useEffect(()=>{
    dispatch(fetchUserLogs(trimSearchValue(tableParams)))
  },[dispatch,
    tableParams.page, tableParams.size,
    debouncedSearchValue,
    tableParams.status,
    tableParams.type,
    tableParams.position,
    tableParams.from_date,
    tableParams.to_date,

  ])

  const handleDateFilter = (dates, dateStrings) => {
    if (!dates) {
      setFilteredData(dataSource);
      return;
    }
    const [startDate, endDate] = dateStrings;
    const filtered = dataSource.filter((item) => {
      const itemDate = new Date(item.date_added);
      return itemDate >= new Date(startDate) && itemDate <= new Date(endDate);
    });
    setFilteredData(filtered);
  };
  const showModal = (actionType) => {
    setModalConfig({ open: true, actionType });
  };

  const closeModal = () => {
    setModalConfig({ open: false, actionType: "" });
  };

  const handleConfirm = () => {
    console.log(`Confirmed ${modalConfig.actionType} action`);
    closeModal();
  };
  const handleSearch = (searchText) => {
    const filtered = dataSource.filter((item) =>
      item.tenant_name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const handleTableChange = (pagination) => {
    setTableParams((prev) => ({
      ...prev,
      page: pagination.current,
      size: pagination.pageSize,
    }));
  };


  const paginationConfig = {
    pageSizeOptions: ["10", "20", "50"], 
    showSizeChanger: true, 
    showQuickJumper: true, 
    total: userCount || 1, 
    current: tableParams.page, 
    pageSize: tableParams.size, 
    type: tableParams.type,
    onChange: (page, pageSize) => {
      setCurrentPage(page); 
      setTableParams((prev) => ({ ...prev, page, size: pageSize }));
    },
  };



  const columns = [
    {
        title: "Sr. No.",
        dataIndex: "sr_no",
        key: "sr_no",
        render: (text, record, index) => (tableParams.page - 1) * tableParams.size + index + 1, 
        width: "100px"
      },
    {
      title: "User Name",
      dataIndex: "user_name_en",
      key: "user_name",
      type: "search",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      type: "search",
    },
    {
        title: "Podcast Name",
        dataIndex: "podcast_title_en",
        key: "podcast_name",
        type: "search",
        render: (text) => (
          <Tooltip title={text}>
            <span style={{ 
              whiteSpace: "nowrap", 
              overflow: "hidden", 
              textOverflow: "ellipsis", 
              display: "inline-block", 
              maxWidth: 250 
            }}>
              {text}
            </span>
          </Tooltip>
        ),
      },
      
    {
      title: "Play Duration",
      dataIndex: "duration",
      key: "play_duration",
    //   type: "search",
      width: "150px",
      render: (durationInSeconds) => {
        const minutes = Math.floor(durationInSeconds / 60);
        const seconds = durationInSeconds % 60;
        return `${minutes}m ${seconds}s`;
      }
    },
    {
      title: "Tenant Name",
      dataIndex: "tenant_name_en",
      key: "tenant_name",
      type: "search",
      width: "120px"
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "date",
      type: "date",
    
    render: (date) => {
        const dateObject = new Date(date);
        const day = String(dateObject.getUTCDate()).padStart(2, '0');       
        const month = String(dateObject.getUTCMonth() + 1).padStart(2, '0'); 
        const year = dateObject.getUTCFullYear();                          
        return `${month}-${day}-${year}`;
      },
    },
  ];
  

  const dataSource = [
    {
      key: "1",
      sr_no: "1",
      user_name: "John Doe",
      email: "john.doe@example.com",
      podcast_name: "Mindful Moments",
      play_duration: "12:34",
      tenant_name: "Wellness Inc.",
      date: "2024-03-01",
    },
    {
      key: "2",
      sr_no: "2",
      user_name: "Jane Smith",
      email: "jane.smith@example.com",
      podcast_name: "Tech Trends",
      play_duration: "45:20",
      tenant_name: "TechWorld",
      date: "2024-02-20",
    },
    {
      key: "3",
      sr_no: "3",
      user_name: "Robert Johnson",
      email: "robert.j@example.com",
      podcast_name: "Startup Stories",
      play_duration: "28:15",
      tenant_name: "InnovateHub",
      date: "2024-01-15",
    },
  ];
  

  const actionItems = () => [
    // {
    //   key: "view",
    //   label: (
    //     <>
    //       <ViewSvg style={{ marginRight: 8 }} />
    //       View Details
    //     </>
    //   ),
    //   onClick: (record) => navigate("view"),
    // },
   
   
    // {
    //   key: "delete",
    //   label: (
    //     <>
    //       <DeleteSvg style={{ marginRight: 8, color: "red" }} />
    //       Delete 
    //     </>
    //   ),
    //   onClick: () => showModal("delete"),
    // },
  ];

  const handleFilterChange = (key, value, reset = false) => {
    setTableParams((prev) => {
      if (reset) {
        return {
          ...prev,
        
          search_key: "",
          search_value: "",
          status: undefined,
          position: undefined,
          from_date: undefined,
          to_date: undefined,
        };
      }
      if (key === "created_at" && (!value || !value.from_date)) {
        return {
          size: prev.size,
          page: prev.page,
          search_key: "",
        };
      }

      if (key === "status" || key==="type" || key === "position") {
        return {
          ...prev,
          [key]: value,
          search_key: "",
          search_value: "",
        };
      }
      if (typeof value === "object" && value?.from_date) {
        return {
          ...prev,
          from_date: value.from_date,
          to_date: value.to_date,
          search_value: "",
          search_key: "",
          status: undefined,
          position: undefined,
        };
      }

      return {
        ...prev,
        search_key: key,
        search_value: value,
        status: undefined,
        position: undefined,
      };
    });
  };
  return (
    <div>
      <div className="addBx">
        <div className="filterBx">
          <Space>
            <CommonFilter
              columns={columns}
              onFilterChange={handleFilterChange}
              searchValue={tableParams.search_value}
            />
          </Space>
        </div>
        {/* <Button
          type="primary"
          icon={<AddSvg />}
          onClick={() => navigate("add-authors")}
        >
          Add Authors
        </Button> */}
      </div>
      <div className="tableHeading">User Activity Log</div>
      <ReusableTable
        columns={columns}
        dataSource={userLogs}
        loading={false}
        paginationConfig={paginationConfig}
        onChange={handleTableChange}
        // actionItems={actionItems}
      />
      <ConfirmModal
        titlePrefix="Author"
        messagePrefix="Author"
        open={modalConfig.open}
        onClose={closeModal}
        onConfirm={handleConfirm}
        actionType={modalConfig.actionType}
      />
    </div>
  );
};

export default UserActivityList;
